import React from 'react';
import ReactDOM from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';
import * as Sentry from '@sentry/react';

import './index.scss';
import App from './App';
import './i18n';
import { logger } from 'RootShared/utility/ErrorLogger';


if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  navigator.serviceWorker.register('/custom-service-worker.js').then(
    function (registration) {
      logger.log('Service worker registration succeeded:', registration);
    },
    function (error) {
      logger.log('Service worker registration failed:', error);
    }
  );
} else {
  logger.log('Service workers are not supported.');
}

smoothscroll.polyfill();
const dsn = process.env.SENTRY_KEY;
if (dsn) {
  Sentry.init({
    dsn: dsn,
    integrations: [
      new Sentry.Integrations.GlobalHandlers({
        onerror: false,
        onunhandledrejection: false,
      }),
    ],
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
